<div class="wrapper">
  <div class="iw-signin-dialog">
    <div class="header iw-bold-18">
      <iw-logo />
    </div>

    <form class="body" [formGroup]="form" (ngSubmit)="verify()">
      <div class="content">
        <div class="text">
          <p
            class="title d-flex flex-col align-center text-center"
            translate="signin.tfa.title"
          ></p>
          <p class="message text-center" translate="signin.tfa.message"></p>
        </div>

        <div class="controls d-flex flex-col">
          <fu-simple-input
            [useOutlineLabel]="false"
            [errorDictionary]="errorDictionary"
            formControlName="code"
            required
            [isHintVisible]="true"
            [hasAutofocus]="true"
            [controlType]="controlType.Text"
            [placeholder]="'signin.tfa.form.placeholder.code' | translate"
            [label]="'signin.tfa.control.code' | translate"
          />
        </div>

        <div class="footer-section">
          <div class="actions">
            <button
              type="submit"
              fuButton
              size="l"
              uiType="primary"
              translate="signin.tfa.btn.verify"
              [disabled]="!form.valid || isLoading"
            ></button>
          </div>

          <div class="footer">
            <p class="footer-message" translate="signin.tfa.help1"></p>
            <button
              fuButton
              uiType="quaternary"
              translate="signin.tfa.help2"
              (click)="openResetDialog()"
            ></button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
